module.exports = new __parcel__URL__("Charlie_Display-Regular.9706825e.woff").toString();